import React from 'react';
import TotalsLine from '../../common/list/TotalsLine';
import { getNumberComma } from '../../../utils/numberUtils';
import { profitRateColor } from '../../chancemng/costcalc/costCalcShared';

// 원가 산출 합계 - 표 위에 떠 있던 Grid 박스 대신 가운뎃점으로 구분한 한 줄(TotalsLine)로.
// chancemng과 동일한 구조(계산 유틸은 chancemng/costcalc/costCalcShared에서 공유).
const CostSummary = ({
  project,
  totalPurchase,
  totalSales,
  totalProfit,
  totalMargin,
}) => {
  const sales = project?.totalSales ? project.totalSales : totalSales;
  const purchase = project?.totalPurchase ? project.totalPurchase : totalPurchase;
  const profit = project?.totalProfit ? project.totalProfit : totalProfit;
  const margin = project?.expBenefitRate !== undefined ? project.expBenefitRate : totalMargin;

  return (
    <TotalsLine
      sx={{ justifyContent: 'flex-start', px: 0 }}
      items={[
        { label: '총 매출액', value: `${getNumberComma(sales)} 원` },
        { label: '총 매입액', value: `${getNumberComma(purchase)} 원` },
        { label: '총 매출이익', value: `${getNumberComma(profit)} 원` },
        { label: '이익율', value: `${margin ?? 0}%`, color: profitRateColor(margin) },
      ]}
    />
  );
};

export default CostSummary;
